import { urlValidator } from '#validation/common/validators';
export const storageEndpointValidator = urlValidator({
    formatError: 'filespace.storageEndpoint.invalidUrl',
    requiredError: 'filespace.storageEndpoint.required',
});
